import { useState } from 'react';
import { useLanguage } from '../contexts/LanguageContext';

function Faqs() {
  const [faqOpen, setFaqOpen] = useState(null);
  const { t, getTranslation } = useLanguage();
  const faqs = getTranslation('faqs') || [];

  return (
    <section className="section section--faqs">
      <div className="section-inner section-inner--narrow">
        <h1 className="section-title">{t('faqsTitle')}</h1>
        <p className="section-intro">
          {t('faqsIntro')}
        </p>
        <div className="faqs">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className={`faq-item ${faqOpen === index ? 'faq-item--open' : ''}`}
            >
              <button
                type="button"
                className="faq-question"
                onClick={() => setFaqOpen(faqOpen === index ? null : index)}
                aria-expanded={faqOpen === index}
              >
                {faq.question}
                <span className="faq-icon" aria-hidden>+</span>
              </button>
              <div className="faq-answer" role="region" aria-hidden={faqOpen !== index}>
                <div className="faq-answer-inner">
                  <p>{faq.answer}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Faqs;
